export default {
  name: 'withLabelField',
  props: ['field']
};